import React from 'react';

import { ReservationCancellationWrapper } from '@components';

import './style.scss';

interface IProps {}

export class ReservationCancellation extends React.Component<IProps, null> {
  render(): React.ReactNode {
    return (
      <div>
        <ReservationCancellationWrapper />
      </div>
    );
  }
}
